<template>
  <div class="slc_w mb-x custom-radio radio-age">
    <label
        v-for="option in options"
        :key="option.value"
        class="slc"
        :class="{ slc_ac: modelValue === option.value }"
        @mouseover="hoveredItem = option.value" @mouseleave="hoveredItem = null"
    >
      <input
          type="radio"
          name="age_above_70"
          :value="option.value"
          :checked="modelValue === option.value"
          @change="$emit('update:modelValue', option.value)"
          class="hidden"

      />
      <img :src="option.icon" loading="lazy" alt="" class="slc_i" />
      <div class="text" v-html="option.label"></div>
    </label>
    <div class="info">
      <small>Pre dojednanie poistenia osôb nad 70 rokov si prosím zadajte samostatnú poistku len pre tieto osoby.</small>
    </div>
  </div>
  <div class="slc_w mb-x" v-if="displayedItem === true && travelReason.includes('WORK')" >
    <div class="slc_info">
      <div class="icoc">
        <div></div>
      </div>
      <div class="co">
        <div class="px mb"> </div>
        <div class="ps">
          <p>Pre osoby nad 70 rokov sa poistenie vzťahuje na výkon práce administratívnej povahy, ktoré je kryté v základnom rozsahu bez príplatku. Pripoistenie manuálnej práce nie je možné dojednať. V prípade záujmu o takéto poistenie nás prosím kontaktujte na info@travelinsurance.sk.</p>
        </div>
      </div>
    </div>
  </div>

<!--  <div class="space-holder">-->
<!--    <div class="slc_w mb-x" v-if="[modelValue, hoveredItem].includes('ADDON')" >-->
<!--      <div class="slc_info">-->
<!--        <div class="icoc">-->
<!--          <div></div>-->
<!--        </div>-->
<!--        <div class="co">-->
<!--          <div class="px mb">STORNO - zrušenie cesty pred odchodom<br></div>-->
<!--          <div class="ps">-->
<!--            pripoistenie k cestovnému poisteniu<br>-->
<!--            poistná suma - cena letenky / vstupenky / zájazdu - pre všetky osoby spolu<br>-->
<!--            predčasný návrat je krytý v základnom rozsahu na limit 600 EUR-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="slc_w mb-x" v-else-if="[modelValue, hoveredItem].includes('SEPARATE')">-->
<!--      <div class="slc_info">-->
<!--        <div class="icoc">-->
<!--          <div></div>-->
<!--        </div>-->
<!--        <div class="co">-->
<!--          <div class="px mb">STORNO - zrušenie cesty pred odchodom + predčasný návrat</div>-->
<!--          <div class="ps">-->
<!--            samostatné poistenie<br>-->
<!--            poistná suma - cena letenky / vstupenky / zájazdu - pre všetky osoby spolu</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
</template>

<script>
import Options from "@/config/options";
export default {
  name: 'AgeSelectRadio',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    travelReason: Array,
  },
  data() {
    return {
      hoveredItem: null,
      options: Options.age_above_70,
    }
  },
  computed: {
    displayedItem(){
      if (this.hoveredItem){
        return this.hoveredItem;
      }else{
        return this.modelValue;
      }
    },
  },
  methods: {}
}
</script>

<style scoped>
.space-holder{
  min-height: 120px;
}
.info{
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  max-width: 50%;

  small{
    //line-height: 1.7;
    //width: 100%;
  }
}
@media all and (max-width: 960px) {
  .info{
    max-width: 100%;
  }
}

</style>
<style>
.radio-age .text small{
  font-weight: 400;
  line-height: 1.1;
}
</style>
